<template>
  <div>
    <div
      v-if="!orgDatasReady"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <div
      v-else
      class="org-list-box"
    >
      <div
        v-if="Object.keys(orgDatas).length <= 0"
        class="no-org-content"
      >
        <!-- <div class="no-org-pic" /> -->
        <i class="icon iconfont iconicon-test38 no-org-pic" />
        <p>{{ $t('message["424"]') }} </p>
        <create-org />
      </div>
      <template
        v-else
      >
        <div class="org-head">
          <h1>选择企业</h1>
          <p>我们将在您选择的企业中为您提供服务</p>
        </div>
        <div
          v-for="(item,index) in orgDatas"
          :key="index"
          class="org-item"
          :org-item-data="item"
          @click.prevent="projectListHandle(item)"
        >
          <i class="iconfont iconicon-test25 org-item-icon" />
          <h3>{{ item.comname }}</h3>
          <span
            v-if="item.isfounder===1"
            class="org-role"
          >{{ $t('message["130"]') }}</span>
          <span
            v-if="item.isadmin===1 && item.isfounder===0"
            class="org-role org-role-admin"
          >{{ $t('message["416"]') }}</span>
          <i class="org-more-icon iconfont iconicon-test73" />
        </div>
        <div
          v-show="!isCreateOrg"
          class="org-item creat-org-btn"
          @click="createOrgHandle"
        >
          <i class="org-item-icon iconfont iconicon-test10" />
          <h3>创建新的组织</h3>
          <span class="create-tip">可用于企业、组织和团队</span>
          <i class="org-more-icon iconfont iconicon-test73" />
        </div>
        <create-org
          v-show="isCreateOrg"
          ref="listCreate"
          @reset="resetHandle"
        />
      </template>
      <!-- <div
        v-else
        class="org-index-box"
      >
        <div class="org-h clearfix">
          <create-org v-if="!$isDingDing" />
          <div
            class="change-list-btn"
            :class="{'change-list-btn2': $isDingDing }"
          >
            <a-checkbox
              :default-checked="ishidden"
              @change="filterPro"
            >
              {{ $t('message["1491"]') }}
            </a-checkbox>
          </div>
        </div>
        <org-item
          v-for="(item,index) in datas"
          :key="index"
          :org-item-data="item"
        />
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import CreateOrg from './index/CreateOrg'
// import { getDingding } from '@/services/index'
// import { isMobile } from '@/lib/device'
export default {
  components: {
    CreateOrg
  },
  data () {
    return {
      isCreateOrg: false
    }
  },
  computed: {
    ...mapState('organization/org', ['orgDatasReady', 'orgDatas']),
    ...mapState(['baseinfo']),
    ishidden () {
      const { 'is_hide_close_pro': isHide } = this.baseinfo
      return isHide === 1
    }
  },
  watch: {
    // ishidden (val) {
    //   this.setIsHidden(val)
    // }
  },
  async mounted () {
    // alert(12)
    // if (this.$store.state.dingding === 'dingtalk') {
    //   this.getData()
    // } else {
    //   const chain = await this.fetchOrgDatas()
    //   chain.fetch()
    // }
    const chain = await this.fetchOrgDatas()
    chain
      .onSuccess(payload => {
        // console.log(payload)
        const cidArr = Object.keys(payload)
        let dingdingCid = this.$isDingDing && cidArr[0]
        // 钉钉内部打开，直接进入项目内
        if (dingdingCid) {
          this.$router.push({
            name: 'ProjectIndexPc',
            query: {
              cid: dingdingCid
            }
          })
        }
      })
      .fetch()
  },
  methods: {
    ...mapActions('organization/org', ['fetchOrgDatas']),
    ...mapMutations('organization/org', ['setIsHidden']),
    ...mapActions(['setSocketMessage', 'permissionMenu']),
    ...mapMutations(['setRoleDefault']),
    /* async getData () {
      const chain = await getDingding()
      chain.onSuccess(async (raw) => {
        await this.specialTo(raw)
      })
        .fetch()
    },
    async specialTo (datas) {
      this.$store.commit('setPid', datas.projectStr)
      let to = ''
      let linkName = ''
      let routerName = 'InqueryList'
      switch (datas.system_role * 1) {
        case 1: // 负责人, 观察员
          linkName = { type: 'inquiry-manager-all', from: 'all' }
          break
        case 2: // 开发
          linkName = { type: 'inquiry-dev', from: 'my' }
          break
        case 3: // 接待
          linkName = { type: 'inquiry-add', from: 'my' }
          break
        default: // 销售
          linkName = { type: 'inquiry-followup', from: 'my' }
      }
      const pid = datas.projectStr // this.$store.state.pid
      // if (!isMobile) {
        if (datas.system_role * 1 === 0) {
          this.setRoleDefault(true)
          const chain = await this.permissionMenu() // 先请求菜单数据，判断自定义角色默认展示页
          chain.params({ cid: datas.cid * 1, projectid: datas.projectid * 1 })
            .onSuccess(res => {
              for (let key in res) {
                if (key === 'inquiry-mine' && res[key]['state']) {
                  let item = res[key]
                  if ('child' in item) {
                    for (let cKey in item['child']) {
                      linkName = { type: cKey, from: 'my' }
                      break
                    }
                  }
                  break
                }
                if (key === 'inquiry-mine' && !res[key]['state']) {
                  // console.log('查重： inquiry-check-repeat')
                  routerName = 'InqueryRepeat'
                  linkName = {}
                  break
                }
              }
            }).onComplete((raw) => {
              // console.log(linkName)
              to = {
                name: routerName,
                params: {
                  pid
                },
                query: linkName
              }
              this.$router.push(to)
            }).fetch()
        } else {
          to = {
            name: routerName,
            params: {
              pid
            },
            query: linkName
          }
          this.$router.push(to)
        }
      } else {
        to = {
          name: 'ProjectIndex',
          params: {
            pid
          }
        }
        this.$router.push(to)
      }
    }, */
    createOrgHandle () {
      this.isCreateOrg = true
      if (this.$refs.listCreate) {
        this.$refs.listCreate.createOrg()
      }
    },
    resetHandle () {
      this.isCreateOrg = false
    },
    projectListHandle (item) {
      this.$router.push({ name: 'ProjectIndexPc',
        query: {
          cid: item.cid
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .no-org-content::v-deep {
    margin: 0 auto;
    text-align: center;
    line-height: 24px;
    font-weight: bold;
    padding: 100px 0 100px;
    box-sizing: content-box;

    .org-create-box {
      float: none !important;
      padding: 0 !important
    }

    .no-org-pic {
      display: block;
      margin: 0 auto 24px;
      font-size: 40px;
      color:#d6d6d6;
    }
    p {
      margin-bottom: 24px;
      color: #b3b3b3;
    }
  }
  .org-list-box::v-deep {
    width: 560px;
    background: #FFF;
    border-radius: 8px;
    border: 1px solid #EBEBEB;
    margin: 24px auto;
    padding: 40px 24px 40px 24px;
    .org-create-box{
      float: none !important;
      padding: 32px 0  0 15px;

    }
     .org-role {
        display: inline-block;
        height: 20px;
        line-height: 20px;
        padding: 0 8px;
        background: #BD7CEB;
        color: #fff;
        border-radius: 10px;
        font-size: 12px;
        vertical-align: middle;
      }

      .org-role-admin {
        background: #4CA0F2;
      }
    .org-item {
      height: 88px;
      position: relative;
      padding:16px 16px 16px 104px;
      //margin-bottom: 32px;
      border-radius: 8px;
      .org-item-icon {
        position: absolute;
        width: 56px;
        height: 56px;
        border-radius: 12px;
        left: 16px;
        top: 16px;
        background: #4ca0f2;
        text-align: center;
        line-height: 56px;
       &.iconicon-test25 {
         color: #fff;
         font-size: 36px;
       }
      }
      .org-more-icon {
        position: absolute;
        right: 16px;
        top: 36px;
        color: #b3b3b3;
      }
      h3{
        height: 24px;
        line-height: 24px;
        font-size: 16px;
        max-width: 320px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-bottom: 12px;
      }
      .create-tip {
        color: #c0c0c0;
      }
      &:hover{
        background: #F4F7F9;
      }
    }
    .creat-org-btn {
      h3 {
        color: #8b8b8b;
      }
      .org-item-icon {
        background: #ebebeb;
        color: #b3b3b3;
        font-size: 24px;
      }
    }
    .org-head {
      text-align: center;
      padding-top: 16px;
      h1{
        font-size: 24px;
        line-height: 32px;
      }
      p{
        color: #b3b3b3;
        font-size: 16px;
        line-height: 24px;
        margin: 16px 0 32px;
      }
    }
  }

  // .org-index-box::v-deep {
  //   .org-h {
  //     padding: 24px 28px 8px;
  //     height: 32px;
  //     box-sizing: content-box;

  //     .reate-org-btn {
  //       float: left;
  //     }
  //      .ant-form-inline .ant-form-item-with-help {
  //       margin-bottom: 0;
  //     }

  //     .change-list-btn {
  //       float: right;
  //       margin-top: 6px;
  //       .ant-checkbox-wrapper {
  //         margin-right: 0;
  //       }
  //     }
  //     .change-list-btn2{
  //       float: left;
  //     }
  //   }
  // }
</style>
